<template lang="pug">
  section.section-content.section-content--recent-location
    .box.w-full
      header.box__header.no-border.flex.items-center.justify-between
        .header-meta
          h2.subheading Recent Location
        .header-cta
      .box__body.p-4
        .flex.flex-wrap(
          v-if="load_data_status_overall_data_location.status === 'loading'"
          class="lg:-mx-2"
        )
          Loading(show="true")
        .flex.flex-wrap(v-else class="lg:-mx-2")
          .block(class="w-full lg:w-1/2 lg:px-2")
            .block.mb-4
              span.block.text-light
                | Operator
              strong.monospace.text-base
                | {{ overall_data_location.data_location && overall_data_location.data_location.operator ? overall_data_location.data_location.operator : (overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features.length > 0 && overall_data_location.recent_location.features[0].properties.provider ? overall_data_location.recent_location.features[0].properties.provider : '-') }}
            .block.mb-4
              span.block.text-light
                | Signal
              strong.monospace.text-base
                | {{ overall_data_location.data_location && overall_data_location.data_location.net_type ? overall_data_location.data_location.net_type : (overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.net ? overall_data_location.recent_location.features[0].properties.net : '-') }}
            .block.mb-4
              span.block.text-light
                | BTS
              strong.monospace.text-base
                | {{ overall_data_location.data_location && overall_data_location.data_location.bts ? overall_data_location.data_location.bts : (overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features.length > 0 && overall_data_location.recent_location.features[0].properties.bts ? overall_data_location.recent_location.features[0].properties.bts : '-') }}
            .block.mb-4
              span.block.text-light
                | Address
              strong.monospace.text-base
                | {{ overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.alamat && overall_data_location.recent_location.features[0].properties.alamat.toString().length > 0 ? overall_data_location.recent_location.features[0].properties.alamat : '-' }}
                
            .block.mb-4
              span.block.text-light
                | Country
              strong.monospace.text-base
                | {{ overall_data_location.data_location && overall_data_location.data_location.country ? overall_data_location.data_location.country : (overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features.length > 0 && overall_data_location.recent_location.features[0].properties.country ? overall_data_location.recent_location.features[0].properties.country : '-') }}
            template(v-if="isAstro === 'true'")
              .block.mb-4
                span.block.text-light
                  | IMEI
                strong.monospace.text-base
                  //- | {{ profile_subheader.imei ? profile_subheader.imei : '-' }}
                  | {{ profile_subheader.imei ? profile_subheader.imei : (overall_data_location.recent_location && overall_data_location.recent_location.features ? overall_data_location.recent_location.features[0].properties.imei : '-') }}
              .block.mb-4
                span.block.text-light
                  | IMSI
                strong.monospace.text-base
                  //- | {{ profile_subheader.imsi ? profile_subheader.imsi : '-' }}
                  | {{ profile_subheader.imsi ? profile_subheader.imsi : (overall_data_location.recent_location && overall_data_location.recent_location.features ? overall_data_location.recent_location.features[0].properties.imsi : '-') }}
            .block.mb-4
              span.block.text-light
                | Date time
              strong.monospace.text-base
                | {{ overall_data_location.data_location && overall_data_location.data_location.datetime ? overall_data_location.data_location.datetime : (overall_data_location.recent_location && overall_data_location.recent_location.features  && overall_data_location.recent_location.features.length > 0 && overall_data_location.recent_location.features[0].properties.dtm ? overall_data_location.recent_location.features[0].properties.dtm : '-') }}
            //- .block.mb-4
              span.block.text-light
                | Information
              strong.monospace.text-base
                | {{ load_data_status_overall_data_location.status && load_data_status_overall_data_location.status === true ? ((overall_data_location.data_location && Object.keys(overall_data_location.heatmap).length > 0 && Object.keys(overall_data_location.recent_location).length > 0 && overall_data_location.recent_location.features && (overall_data_location.recent_location.features[0].geometry.coordinates[0] !== '' && overall_data_location.recent_location.features[0].geometry.coordinates[0] !== null) && (overall_data_location.recent_location.features[0].geometry.coordinates[1] !== '' && overall_data_location.recent_location.features[0].geometry.coordinates[1] !== null)) ? 'Success load data.' : 'Failed load data, some data is missing or something wrong.') : '-' }}
          //-
          template(v-if="(overall_data_location.data_location && (Object.keys(overall_data_location.heatmap).length > 0 || Object.keys(overall_data_location.recent_location).length > 0)) && mapLoaded")
            .block(v-if="vendorMap==='osm'" class="w-full lg:w-1/2 lg:px-2")
              .box-map(:class="isAstro === 'true' ? 'map-astro' : ''")
                div.openmapstreet
                  l-map(:id="id" :zoom="10" :center="center" :options="options" style="height: 355px;width: 700px;")
                    l-tile-layer(:url="url" :attribution="attribution")
                    l-marker(v-for="(location, index) in locations" :lat-lng="location.position" v-bind:key="index")
                      l-popup(:content="location.name")
                    LeafletHeatmap(:lat-lng="latLngHeat" :max="maxHeat" :radius="radHeat" :maxZoom="10")

            .block(v-else class="w-full lg:w-1/2 lg:px-2")
              .box-map(:class="isAstro === 'true' ? 'map-astro' : ''")
                gmap-map(ref="mapRef" :center="center" :zoom="10" :options="options" style="width:100%; height: 100%;")

          .block(v-else class="w-full lg:w-1/2 lg:px-2")
            .box-map(:class="isAstro === 'true' ? 'map-astro' : ''")
              NoDataAvailable

                    
</template>

<script>
import { mapState } from 'vuex';
import { gmapApi } from 'vue2-google-maps';
import moment from 'moment';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';

// openmapstreet
import {LMap, LTileLayer, LMarker, LPopup} from 'vue2-leaflet';
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
// import LeafletHeatmap from 'LeafletHeatmap'
// import LeafletHeatmap from 'vue2-leaflet-heatmap';
import LeafletHeatmap from '@/components/LeafletHeatmap.vue';

import 'leaflet.heat';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.imagePath = ''
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

export default {
    name: 'OverallRecentLocation',
    props: ['isKey'],
    components: {
        Loading,
        NoDataAvailable,

        // opemapstreet
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LeafletHeatmap,
    },
    data() {
        return {
            infoWindows: [],
            mapLoaded: false,
            options: {
                // zoomControl: true,
                // mapTypeControl: true,
                // scaleControl: true,
                // streetViewControl: true,
                // rotateControl: true,
                // fullscreenControl: false,
                // disableDefaultUi: false
                // scrollwheel: false,
                gestureHandling: 'cooperative',
                styles: [
                    {elementType: 'geometry', stylers: [{color: '#242f3e'}]},
                    {elementType: 'labels.text.stroke', stylers: [{color: '#242f3e'}]},
                    {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
                    {
                      featureType: 'administrative.locality',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}]
                    },
                    {
                      featureType: 'poi',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}]
                    },
                    {
                      featureType: 'poi.park',
                      elementType: 'geometry',
                      stylers: [{color: '#263c3f'}]
                    },
                    {
                      featureType: 'poi.park',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#6b9a76'}]
                    },
                    {
                      featureType: 'road',
                      elementType: 'geometry',
                      stylers: [{color: '#38414e'}]
                    },
                    {
                      featureType: 'road',
                      elementType: 'geometry.stroke',
                      stylers: [{color: '#212a37'}]
                    },
                    {
                      featureType: 'road',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#9ca5b3'}]
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'geometry',
                      stylers: [{color: '#746855'}]
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'geometry.stroke',
                      stylers: [{color: '#1f2835'}]
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#f3d19c'}]
                    },
                    {
                      featureType: 'transit',
                      elementType: 'geometry',
                      stylers: [{color: '#2f3948'}]
                    },
                    {
                      featureType: 'transit.station',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}]
                    },
                    {
                      featureType: 'water',
                      elementType: 'geometry',
                      stylers: [{color: '#17263c'}]
                    },
                    {
                      featureType: 'water',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#515c6d'}]
                    },
                    {
                      featureType: 'water',
                      elementType: 'labels.text.stroke',
                      stylers: [{color: '#17263c'}]
                    }
                ],
            },
            // center: { 
            //     lng: parseFloat(this.$store.state.overall_recent_location.features[0].geometry.coordinates[0]),
            //     lat: parseFloat(this.$store.state.overall_recent_location.features[0].geometry.coordinates[1]),
            // },
            center: {},
            markers: [],
            places: [],
            // myLatlng: null,
            isAstro: process.env.VUE_APP_ASTRO,
            vendorMap: (typeof process.env.VUE_APP_VENDOR_MAP!==undefined? process.env.VUE_APP_VENDOR_MAP: 'gmap'),

            // openmapstreet
            // url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
            url: `${process.env.VUE_APP_OSM_CDN_URL}{z}/{x}/{y}.png`,
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            locations: [],
            id: 'openmapstreet-recent_location',
            newLoc: '',
            newLt : 0, 
            newLng : 0,
            icon: L.icon({iconUrl: "null",}),
            latLngHeat: [
                // [-7.782, 110.424, (3/41)],
                // [-7.824, 110.48097, (3/41)],
                // [-7.7147, 110.6167667, (5/41)],
                // [-7.7562, 110.70192, (2/41)],
                // [-7.8191, 110.389, (4/41)],
                // [-7.69522, 110.564, (1/41)],
                // [-7.69972, 110.612, (2/41)],
                // [-7.70456, 110.604, (1/41)],
                // [-7.70503, 110.612, (1/41)],
                // [-7.71075, 110.603, (1/41)],
                // [-7.71322, 110.59, (2/41)],
                // [-7.71504, 110.59896, (2/41)],
                // [-7.71532, 110.68814, (1/41)],
                // [-7.72067, 110.5803, (7/41)],
                // [-7.72186, 110.558, (8/41)],
                // [-7.72556, 110.538, (5/41)],
                // [-7.72835, 110.45319, (1/41)],
                // [-7.72992, 110.628, (6/41)],
                // [-7.73368, 110.68725, (2/41)],
                // [-7.73568, 110.61819, (2/41)],
                // [-7.73577, 110.66273, (5/41)],
                // [-7.73938, 110.536467, (1/41)],
                // [-7.74169, 110.47309, (2/41)],
                // [-7.74508, 110.524, (2/41)],
                // [-7.75022, 110.664, (3/41)],
                // [-7.75122, 110.51219, (2/41)],
                // [-7.75144, 110.49706, (3/41)],
                // [-7.75442, 110.483, (6/41)],
                // [-7.76264, 110.474, (3/41)],
                // [-7.76323, 110.637, (2/41)],
                // [-7.76464, 110.4915, (7/41)],
                // [-7.76472, 110.421, (1/41)],
                // [-7.77956, 110.431, (2/41)],
                // [-7.77958, 110.44498, (1/41)],
                // [-7.77975, 110.452, (2/41)],
                // [-7.77989, 110.414, (4/41)],
                // [-7.78147, 110.482, (39/41)],
                // [-7.78267, 110.401, (1/41)],
                // [-7.78505, 110.515, (18/41)],
                // [-7.79245, 110.407, (2/41)],
                // [-7.79721, 110.49714, (7/41)],
                // [-7.80097, 110.403, (2/41)],
                // [-7.80153, 110.409, (2/41)],
                // [-7.80577, 110.398, (2/41)],
                // [-7.80587, 110.412, (2/41)],
                // [-7.81361, 110.483, (11/41)],
                // [-7.81389, 110.382, (2/41)],
                // [-7.81449, 110.41001, (3/41)],
                // [-7.81872, 110.397, (4/41)],
                // [-7.82232, 110.46862, (5/41)],
                // [-7.82379, 110.373, (1/41)],
                // [-7.82672, 110.38464, (41/41)],
                // [-7.83583, 110.52, (3/41)],
                // [-7.84256, 110.486, (1/41)],
                // [-7.732303, 110.558427, (3/41)],
                // [-7.752614, 110.687708, (8/41)]
            ],
            maxHeat: 1.0,
            radHeat: 30,
        };
    },
    computed: {
        ...mapState([
          'load_data_status_overall_data_location',
          'overall_data_location',
          // 'overall_recent_location',
          'profile_subheader',
        ]),
        google: gmapApi,
    },
    watch: {
        // overall_data_location (newData, oldData) {
        overall_data_location () {
            // Our fancy notification (2).
            // console.log('====== watch on RecentLocation.vue')
            // console.log({newData, oldData})
            
            this.startMap();
        },
        google() {},
    },
    methods: {
        hideAllInfoWindows() {
            for (var i=0; i < this.infoWindows.length; i++) {
                this.infoWindows[i].close();
            }
        },
        moment: function (string, string_format, format) {
            return moment(string, string_format).format(format);
        },
        startMap() {
            switch(this.vendorMap) {
              case 'osm':
                this.startMapOSM();
                break;
              default:
                this.startMapGMAP();
                break;
            }
        },
        startMapGMAP() {
            // console.log('start Map')
            var self = this;
            var location = [];
            self.markers = [];
            self.infoWindows = [];
            // const google = self.google;

            if(typeof this.overall_data_location.recent_location !== undefined && typeof this.overall_data_location.recent_location !== 'undefined' && this.overall_data_location.recent_location !== null){
                location = this.overall_data_location.recent_location
            } else {
                return;
            }

            if (Object.keys(location).length > 0 || Object.keys(this.overall_data_location.heatmap).length > 0) {
                

                var result = Object.keys(location).length > 0 ? location.features[0] : null;

                var lng = parseFloat(result && result.geometry.coordinates[0] ? result.geometry.coordinates[0] : (this.overall_data_location && this.overall_data_location.heatmap && this.overall_data_location.heatmap[0] && this.overall_data_location.heatmap[0][1] ? this.overall_data_location.heatmap[0][1] : 0));

                var lat = parseFloat(result && result.geometry.coordinates[1] ? result.geometry.coordinates[1] : (this.overall_data_location && this.overall_data_location.heatmap && this.overall_data_location.heatmap[0] && this.overall_data_location.heatmap[0][0] ? this.overall_data_location.heatmap[0][0] : 0));

                // for marker
                // var dtm = moment().format('DD MMMM YYYY, hh:mm');
                // var dtm = (result && result.properties.dtm ? moment(result.properties.dtm, 'YYYY-MM-DDTHH:mm:ss').format('DD MMMM YYYY, HH:mm') : '-');
                var dtm = (result && result.properties.dtm ? result.properties.dtm : '-');
                
                // var bts = (this.overall_data_location.data_location && this.overall_data_location.data_location.bts ? this.overall_data_location.data_location.bts : '-');
                var bts = (this.overall_data_location.data_location && this.overall_data_location.data_location.bts ? this.overall_data_location.data_location.bts : (result && result.properties.bts ? result.properties.bts : '-'));
                var state = (result && result.properties.state ? result.properties.state : '-');

                // console.log('lan, lng on recent location : ');
                // console.log({lat, lng});

                var name = result ? result.properties.name : '-';
                // set_map(name, lat, lng, results.heatmap)

                if (Number.isNaN(lat) || Number.isNaN(lng)) {
                    return;
                }

                this.center = {
                    lat: lat,
                    lng: lng,
                };
                // console.log('center :')
                // console.log(this.center)

                this.mapLoaded = true;
                // console.log('mapLoaded :')
                // console.log(this.mapLoaded)

                // ------------------------------------------------------

                // if (this.overall_data_location.heatmap == null) {
                //     this.$nextTick(() => {
                //         this.$refs.mapRef.$mapPromise.then((map) => {
                //             map.zoom = 10;
                //         });
                //     });
                // }

                // console.log('before if else map')
                // map config
                if (self.overall_data_location.heatmap != null && typeof self.overall_data_location.heatmap[0] !== 'undefined' && typeof self.overall_data_location.heatmap[0] !== undefined ) {
                    
                    // console.log('if map')

                    self.$nextTick(() => {
                        let mapPromise = self.$refs.mapRef.$mapPromise
                        // if (mapPromise !== undefined){
                        mapPromise.then((map) => {
                            const google = self.google;

                            map.center = new google.maps.LatLng(self.center);
                            map.zoom = 10;

                            // eslint-disable next-line
                            var marker = new google.maps.Marker({
                                position: new google.maps.LatLng(self.center),
                                map: map,
                                // title: name,
                            });
                            // console.log(marker)
                            self.markers.push(marker);

                            // var marker2 = new google.maps.Marker({
                            //     position: new google.maps.LatLng({
                            //         lat: -6.2256095,
                            //         lng: 106.7754866
                            //     }),
                            //     map: map 
                            // });
                            // self.markers.push(marker2);

                            // -------------------------
                            var contentString = '<div id="content">'+
                              '<div id="bodyContent">'+
                                  // '<p>Link Location: <strong><a target="_blank" href="https://www.google.com/maps?q='+self.center.lat+','+self.center.lng+'">'+
                                  // 'Google Maps</a></strong> '+
                                  // '</p>'+
                                '<table>'+
                                  '<tr>'+
                                    '<td class="pr-1">Last Updated</td>'+
                                    '<td class="pr-1">:</td>'+
                                    '<td>'+dtm+'</td>'+
                                  '</tr>'+
                                  '<tr>'+
                                    '<td>BTS</td>'+
                                    '<td>:</td>'+
                                    '<td>'+bts+'</td>'+
                                  '</tr>'+
                                  '<tr>'+
                                    '<td>State</td>'+
                                    '<td>:</td>'+
                                    '<td>'+state+'</td>'+
                                  '</tr>'+
                                  '<tr>'+
                                    '<td>Link Location</td>'+
                                    '<td>:</td>'+
                                    '<td><a target="_blank" href="https://www.google.com/maps?q='+self.center.lat+','+self.center.lng+'" style="color: #43ea92;">'+'Google Maps</a> '+
                                    '</td>'+
                                  '</tr>'+
                                '</table>'+
                              '</div>'+
                            '</div>';

                            const infowindow = new google.maps.InfoWindow({
                                content: contentString,
                                maxWidth: 300
                            });
                            
                            self.infoWindows.push(infowindow);

                            // -------------------------
                            // var contentString2 = '<div id="content">'+
                            //       '<div id="bodyContent">'+
                            //       '<p>Link Location 2: <strong><a target="_blank" href="https://www.google.com/maps?q='+-6.2256095+','+106.7754866+'">'+
                            //       'Google Maps</a></strong> '+
                            //       '</p>'+
                            //       '</div>'+
                            //       '</div>';

                            // const infowindow2 = new google.maps.InfoWindow({
                            //     content: contentString2,
                            //     maxWidth: 200
                            // });
                            
                            // self.infoWindows.push(infowindow2); 
                            
                            google.maps.event.addListener(marker, 'click', function() {
                              // self.hideAllInfoWindows(map);
                              self.hideAllInfoWindows();
                              infowindow.open(map, marker);
                            });

                            // google.maps.event.addListener(marker2, 'click', function() {
                            //   // self.hideAllInfoWindows(map);
                            //   self.hideAllInfoWindows();
                            //   infowindow2.open(map, marker2);
                            // });
                            // -------------------------

                            var heatmapData = [];
                            self.overall_data_location.heatmap.forEach(function(coord) {
                                heatmapData.push(new google.maps.LatLng(coord[0], coord[1]));
                            });

                            var setHeatmap = new google.maps.visualization.HeatmapLayer({
                              data: heatmapData,
                              map: map
                            });

                            var bounds = new google.maps.LatLngBounds();

                            // Extend bounds with each point
                            for (var i = 0; i < heatmapData.length; i++) {
                                bounds.extend(heatmapData[i]);
                            }

                            // add marker to bounds
                            bounds.extend(new google.maps.LatLng(self.center.lat, self.center.lng));

                            // Apply fitBounds
                            map.fitBounds(bounds);

                            setHeatmap.setMap(map);
                            setHeatmap.set('radius', 30);
                        });
                        // }
                    });
                } else {
                    // console.log('else map')

                    self.$nextTick(() => {
                        let mapPromise = self.$refs.mapRef.$mapPromise
                        // if (mapPromise !== undefined){
                            mapPromise.then((map) => {
                                const google = self.google;

                                // map.center = self.myLatlng;
                                map.center = new google.maps.LatLng(self.center);
                                map.zoom = 10;

                                var marker = new google.maps.Marker({
                                    position: new google.maps.LatLng(self.center),
                                    // position: self.myLatlng,
                                    map: map,
                                    title: name,
                                });

                                // console.log(name)
                                
                                // marker.setMap(map);
                                var contentString = '<div id="content">'+
                                  '<div id="bodyContent">'+
                                      // '<div id="bodyContent">'+
                                      // '<p>Link Location: <a target="_blank" href="https://www.google.com/maps?q='+lat+','+lng+'">'+
                                      // 'Google Maps</a> '+
                                      // '</p>'+
                                    '<table>'+
                                      '<tr>'+
                                        '<td class="pr-1">Last Updated</td>'+
                                        '<td class="pr-1">:</td>'+
                                        '<td>'+dtm+'</td>'+
                                      '</tr>'+
                                      '<tr>'+
                                        '<td>BTS</td>'+
                                        '<td>:</td>'+
                                        '<td>'+bts+'</td>'+
                                      '</tr>'+
                                      '<tr>'+
                                        '<td>State</td>'+
                                        '<td>:</td>'+
                                        '<td>'+state+'</td>'+
                                      '</tr>'+
                                      '<tr>'+
                                        '<td>Link Location</td>'+
                                        '<td>:</td>'+
                                        '<td><a target="_blank" href="https://www.google.com/maps?q='+lat+','+lng+'" style="color: #43ea92;">'+'Google Maps</a> '+
                                        '</td>'+
                                      '</tr>'+
                                    '</table>'+
                                  '</div>'+
                                '</div>';

                                var infowindow = new google.maps.InfoWindow({
                                    content: contentString,
                                    maxWidth: 300,
                                });

                                self.infoWindows.push(infowindow);
                                
                                // marker.addListener('click', function() {
                                google.maps.event.addListener(marker, 'click', function() {
                                    infowindow.open(map, marker);
                                });
                            });
                        // }
                    });
                }
            }
        },
        startMapOSM() {
            // console.log('start Map')
            var self = this;
            var location = [];
            self.locations = [];
            self.latLngHeat = [];
            // const google = self.google;

            if(typeof this.overall_data_location.recent_location !== undefined && typeof this.overall_data_location.recent_location !== 'undefined' && this.overall_data_location.recent_location !== null){
                location = this.overall_data_location.recent_location
            } else {
                return;
            }

            if (Object.keys(location).length > 0 || Object.keys(this.overall_data_location.heatmap).length > 0) {
                

                var result = Object.keys(location).length > 0 ? location.features[0] : null;

                var lng = parseFloat(result && result.geometry.coordinates[0] ? result.geometry.coordinates[0] : (this.overall_data_location && this.overall_data_location.heatmap && this.overall_data_location.heatmap[0] && this.overall_data_location.heatmap[0][1] ? this.overall_data_location.heatmap[0][1] : 0));

                var lat = parseFloat(result && result.geometry.coordinates[1] ? result.geometry.coordinates[1] : (this.overall_data_location && this.overall_data_location.heatmap && this.overall_data_location.heatmap[0] && this.overall_data_location.heatmap[0][0] ? this.overall_data_location.heatmap[0][0] : 0));

                // for marker
                // var dtm = moment().format('DD MMMM YYYY, hh:mm');
                // var dtm = (result && result.properties.dtm ? moment(result.properties.dtm, 'YYYY-MM-DDTHH:mm:ss').format('DD MMMM YYYY, HH:mm') : '-');
                var dtm = (result && result.properties.dtm ? result.properties.dtm : '-');
                // var bts = (this.overall_data_location.data_location && this.overall_data_location.data_location.bts ? this.overall_data_location.data_location.bts : '-');
                var bts = (this.overall_data_location.data_location && this.overall_data_location.data_location.bts ? this.overall_data_location.data_location.bts : (result && result.properties.bts ? result.properties.bts : '-'));
                var state = (result && result.properties.state ? result.properties.state : '-');

                // console.log('lan, lng on recent location : ');
                // console.log({lat, lng});

                // var name = result ? result.properties.name : '-';
                // set_map(name, lat, lng, results.heatmap)

                if (Number.isNaN(lat) || Number.isNaN(lng)) {
                    return;
                }

                this.center = {
                    lat: lat,
                    lng: lng,
                };
                // console.log('center :')
                // console.log(this.center)

                this.mapLoaded = true;
                // console.log('mapLoaded :')
                // console.log(this.mapLoaded)

                // ------------------------------------------------------

                // if (this.overall_data_location.heatmap == null) {
                //     this.$nextTick(() => {
                //         this.$refs.mapRef.$mapPromise.then((map) => {
                //             map.zoom = 10;
                //         });
                //     });
                // }

                // console.log('before if else map')
                // map config
                var contentString = '<div id="content">'+
                  '<div id="bodyContent">'+
                   '<table>'+
                      '<tr>'+
                        '<td class="pr-1">Last Updated</td>'+
                        '<td class="pr-1">:</td>'+
                        '<td>'+dtm+'</td>'+
                      '</tr>'+
                      '<tr>'+
                        '<td>BTS</td>'+
                        '<td>:</td>'+
                        '<td>'+bts+'</td>'+
                      '</tr>'+
                      '<tr>'+
                        '<td>State</td>'+
                        '<td>:</td>'+
                        '<td>'+state+'</td>'+
                      '</tr>'+
                      '<tr>'+
                        '<td>Link Location</td>'+
                        '<td>:</td>'+
                        '<td><a target="_blank" href="https://www.google.com/maps?q='+self.center.lat+','+self.center.lng+'" style="color: #43ea92;">'+'Google Maps</a> '+
                        '</td>'+
                      '</tr>'+
                    '</table>'+
                  '</div>'+
                '</div>';
                let centerTmp = [self.center['lat'], self.center['lng']]
                self.locations.push({name:contentString,position:centerTmp})
                if (self.overall_data_location.heatmap != null && typeof self.overall_data_location.heatmap[0] !== 'undefined' && typeof self.overall_data_location.heatmap[0] !== undefined ) {
                    var heatmapData = {};
                    var maxValue = 0;
                    var heatmapDataFix = []
                    self.overall_data_location.heatmap.forEach(function(coord) {
                        // var arr = [coord[0], coord[1], 0.1];
                        // heatmapDataFix.push(arr)
                        if(heatmapData[coord[0]+','+coord[1]]){
                            heatmapData[coord[0]+','+coord[1]][2] += 1;
                        } else {
                            heatmapData[coord[0]+','+coord[1]]= [coord[0], coord[1], 1];
                        }
                        if (maxValue<heatmapData[coord[0]+','+coord[1]][2]){
                            maxValue = heatmapData[coord[0]+','+coord[1]][2]
                        }
                    });
                    // console.log({heatmapData})
                    // if (heatmapData.length){
                    if (maxValue>0){
                        Object.values(heatmapData).forEach(function(arr) {
                            arr[2] = arr[2]/maxValue
                            heatmapDataFix.push(arr)
                        });
                        // console.log({heatmapDataFix})
                        self.latLngHeat = heatmapDataFix
                    }
                }
            }
        },
    },
    mounted() {
        // this.$nextTick(() => {
        //   this.$refs.marker.mapObject.openPopup();
        // });
        // this.newLoc = this.locations[0].name
        // this.newLt = this.locations[0].position[0]
        // this.newLng = this.locations[0].position[1]
        // console.log('=============== mounted on RecentLocation.vue')
        // console.log(this.isKey)
        if (this.isKey)
            this.startMap();
    },
}
</script>

<style lang="sass">
.box-map
    width: 100%
    // height: 320px
    height: 355px
    display: flex
    align-items: center
    justify-content: center
    iframe
        width: 100%
        height: 100%
.box-map.map-astro
        height: 450px

.leaflet-top,
.leaflet-bottom
    z-index: 400 !important

</style>
